import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ChevronLeft, Clock, Award } from 'lucide-react';

const getDifficultyColor = (difficulty) => {
  if (difficulty === 'Easy') return '#00FF00';
  if (difficulty === 'Medium') return '#FF9500';
  if (difficulty === 'Hard') return '#FF0055';
  if (difficulty === 'Insane') return '#9D00FF';
  return '#FFFFFF';
};

/**
 * Top of the RoomDetail page — back button + title + difficulty badge +
 * description + metadata strip (time estimate, points, type).
 */
export const RoomHeader = ({ room }) => {
  const navigate = useNavigate();
  const color = getDifficultyColor(room.difficulty);

  return (
    <>
      <Button
        variant="ghost"
        onClick={() => navigate('/rooms')}
        className="mb-6 text-gray-400 hover:text-white hover:bg-gray-800"
        data-testid="room-back-btn"
      >
        <ChevronLeft className="w-4 h-4 mr-2" />
        Back to Rooms
      </Button>

      <div className="mb-8" data-testid="room-header">
        <div className="flex items-center gap-3 mb-3">
          <h1 className="text-4xl font-bold">{room.title}</h1>
          <Badge
            style={{
              backgroundColor: `${color}20`,
              color,
              borderColor: color,
            }}
          >
            {room.difficulty}
          </Badge>
        </div>
        <p className="text-gray-400 text-lg mb-4">{room.description}</p>
        <div className="flex items-center gap-6 text-sm">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-gray-400" />
            <span className="text-gray-300">{room.timeEstimate || '30 min'}</span>
          </div>
          <div className="flex items-center gap-2">
            <Award className="w-4 h-4 text-[#00FF00]" />
            <span className="text-[#00FF00]">{room.points} points</span>
          </div>
          <Badge variant="outline" className="border-gray-700 text-gray-300">
            {room.type || 'Challenge'}
          </Badge>
        </div>
      </div>
    </>
  );
};
